<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="about">
    <main>
      <section class="hero-section">
        <h1>关于超天才量化开源技术服务</h1>
        <p>量化深研平台致力于打造面向 A 股市场的专业 AI 量化投研基础设施。<br>我们希望降低量化研究工具门槛，让严谨、可复现的量化研究能力，赋能更多个人与机构投资用户。</p>
      </section>

      <section class="values-section">
        <h2>三大理念</h2>
        <div class="values">
          <article class="value-card">
            <div class="value-icon">✓</div>
            <h3>严谨优先</h3>
            <p>所有模型、因子、策略结果可验证</p>
          </article>
          <article class="value-card">
            <div class="value-icon">⚡</div>
            <h3>开放能力</h3>
            <p>提供 API 服务，支持与外部系统打通</p>
          </article>
          <article class="value-card">
            <div class="value-icon">↻</div>
            <h3>持续迭代</h3>
            <p>跟随市场变化更新因子库与 AI 模型</p>
          </article>
        </div>
      </section>

      <section class="contact-section">
        <h2>联系我们</h2>
        <div class="contact-info">
          <div class="contact-item">
            <span class="contact-label">商务合作</span>
            <span class="contact-value"></span>
          </div>
          <div class="contact-item">
            <span class="contact-label">技术对接</span>
            <span class="contact-value"></span>
          </div>
          <div class="contact-item">
            <span class="contact-label">产品建议</span>
            <span class="contact-value"></span>
          </div>
          <div class="contact-item">
            <span class="contact-label">邮箱</span>
            <span class="contact-value"></span>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.about {
  font-family: "Microsoft YaHei", Arial, sans-serif;
  color: #171717;
  padding-top: 72px;
  min-height: 100vh;
  background: #f8f9fa;
}

.about main {
  max-width: 1200px;
  margin: 0 auto;
}

.hero-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 120px 24px;
  text-align: center;
  color: white;
}

.hero-section h1 {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 24px;
}

.hero-section p {
  font-size: 18px;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
  opacity: 0.95;
}

.values-section {
  padding: 100px 24px;
  background: white;
}

.values-section h2 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 60px;
  color: #1a1a1a;
}

.values {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 32px;
  max-width: 1000px;
  margin: 0 auto;
}

.value-card {
  background: #f8f9fa;
  padding: 40px 32px;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.value-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  border-color: #1890ff;
  background: white;
}

.value-icon {
  font-size: 48px;
  margin-bottom: 20px;
  color: #1890ff;
}

.value-card h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #1a1a1a;
}

.value-card p {
  font-size: 15px;
  line-height: 1.8;
  color: #595959;
}

.contact-section {
  padding: 100px 24px;
  background: #f8f9fa;
}

.contact-section h2 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 60px;
  color: #1a1a1a;
}

.contact-info {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 48px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.contact-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.contact-item:last-child {
  border-bottom: none;
}

.contact-item:hover {
  background: rgba(24, 144, 255, 0.02);
  padding-left: 16px;
  padding-right: 16px;
}

.contact-label {
  font-size: 15px;
  font-weight: 500;
  color: #595959;
}

.contact-value {
  font-size: 15px;
  color: #1a1a1a;
}

@media (max-width: 768px) {
  .hero-section {
    padding: 80px 24px;
  }

  .hero-section h1 {
    font-size: 28px;
  }

  .hero-section p {
    font-size: 16px;
  }

  .values-section h2,
  .contact-section h2 {
    font-size: 24px;
  }

  .values {
    grid-template-columns: 1fr;
  }

  .contact-info {
    padding: 32px 24px;
  }

  .contact-item {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
}
</style>
